var liked = {
	// selectors: { },

	init: function () {
		var self = this;

		self.loadLiked();
		self.maybeLikeItem();
	},

	maybeLikeItem: function() {
		var self = this;

		// no likes on this page, just bail
		if( document.querySelectorAll( '[data-like]' ).length == 0 ) {
			return false;
		}

		document.querySelectorAll( '[data-like]' ).forEach(( likeItem ) => {
			likeItem.addEventListener( 'click' , ( event ) => {
				event.preventDefault();

				if( pctVars.loggedIn != '1' ) {

					jQuery.fancybox.open({
						src  : '.logged-in-action.like-modal',
						type : 'inline',
						touch: false,
					});

					return false;
				}

				const type 		= ( event.target.classList.contains( 'liked' ) ) ? 'remove' : 'add';
				const post_id 	= event.target.getAttribute( 'data-like' );

				self.pctApiCall({
					action: 'maybe_like_item',
					like_type: type,
					post_id: event.target.getAttribute( 'data-like' ),
				}).then( response => {
		
					// do stuff
					// console.log( response );
		
					if( ! response.success ) {
						return false;
					}
		
					if( ! response.data.status ) {
						jQuery( '.general-modal h2' ).text( response.data.message );

						jQuery.fancybox.open({
							src  : '.general-modal',
							type : 'inline',
							touch: false,
						});

						return false;
					}

					document.querySelectorAll( `[data-like="${post_id}"]` ).forEach(( likeItem ) => {
						if( type == 'add' ) likeItem.classList.add( 'liked' );
						if( type == 'remove' ) likeItem.classList.remove( 'liked' );
					});
		
				}).catch(error => {
					console.error( 'Error loading likes: ' , error); 
				});
			});
		});
	},

	loadLiked: function() {
		var self = this;

		// user not logged in, just bail
		if( pctVars.loggedIn != '1' ) {
			return false;
		}

		// no likes on this page, just bail
		if( document.querySelectorAll( '[data-like]' ).length == 0 ) {
			return false;
		}

		self.pctApiCall({
			action: 'get_liked',
		}).then( response => {

			// do stuff
			// console.log( response );

			if( ! response.success ) {
				return false;
			}

			if( response.data.liked_items.length == 0 ) {
				return false;
			}

			response.data.liked_items.forEach( item => {
				let post_id = item.split( '/' )[0];

				if( item.split( '/' )[1].includes( '_categories' ) ) {
					post_id = `t-${post_id}`;
				}

				document.querySelectorAll( `[data-like="${post_id}"]` ).forEach(( likeItem ) => {
					likeItem.classList.add( 'liked' );
				});
			});

		}).catch(error => {
			console.error( 'Error loading likes: ' , error); 
		});
	},

	pctApiCall: function( data, ) {
		return new Promise((resolve, reject) => {
			jQuery.ajax({
				type: 'POST',
				url: pctVars.ajax_url,
				dataType: 'json',
				cache: false,
				// contentType: 'application/json', 
				// data: JSON.stringify( data ),
				data: data,
				success: function( response ){
					resolve(response);
				},
				error: function( response ){
					console.log( '^^^^^^^^^^^^^^^^^' );
					console.log( response );
				},
			}).done(function(data, textStatus, jqXHR) {
				//console.log("Success: ", data);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				console.log( '--------' );
				console.log("Error: ", jqXHR);
				console.log("Error: ", textStatus);
				console.log("Error: ", errorThrown);
			});
		});
	},
};

export { liked };